import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const TASK_ITEM_CONTENT_SCHEMA = Object.freeze({
  TITLE: '',
  ACTION_URL: '',
  COMPLETE_ON_TAP: false,
});
export const RECORD = generateSchema(TASK_ITEM_CONTENT_SCHEMA);
export const KEYS: any = generateKeys(TASK_ITEM_CONTENT_SCHEMA);

export class TaskItemContent extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get actionUrl(): string {
    return this.get(KEYS.ACTION_URL);
  }

  get completeOnTap(): boolean {
    return this.get(KEYS.COMPLETE_ON_TAP);
  }
}
